import { useCallback, useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import { MessageType, getMessagesType } from "./MessagesType";
import { Table } from "../Table/Table";
import { useNavigate } from "react-router-dom";
import "./Messages.css";

export const Messages = () => {
  const [messageList, setMessageList] = useState([] as MessageType[]);
  const [filteredMessageList, setFilteredMessageList] = useState<any>([]);
  const navigate = useNavigate();

  const handleMessages = async () => {
    const messages = (await API.graphql(
      graphqlOperation(queries.getMessages)
    )) as GraphQLResult<getMessagesType>;
    setMessageList(messages?.data?.getMessages);
    console.log(messageList);
    filterMessages(messages);
  };

  const selectMessage = (row, isSelect, rowIndex, e) => {
    navigate(`/messages/${row.id}`);
  };

  const filterMessages = useCallback(
    async (messages) => {
      const filteredMessages = messages?.data?.getMessages?.map((message) => {
        return { ...message, Active: !message.Active ? "❌" : "✅" };
      });
      setFilteredMessageList(filteredMessages);
      console.log("filtered" + filteredMessageList);
    },
    [messageList]
  );

  useEffect(() => {
    handleMessages();
  }, []);

  return (
    <div>
      <div className="title-messages">Messages</div>
      <div style={{ display: "flex", flex: 1 }}>
        <Table
          tableRows={filteredMessageList}
          excludeKeys={[
            "Summary",
            "Description",
            "TMCUsers",
            "TIUsers",
            "Renewals",
            "Marketing",
            "StartDate",
            "EndDate",
            "MatchAll",
            "id",
          ]}
          pagination={10}
          handleSelect={selectMessage}
        />
      </div>
    </div>
  );
};
